import { render, staticRenderFns } from "./ViNavBar.vue?vue&type=template&id=6aa6258c&scoped=true"
import script from "./ViNavBar.vue?vue&type=script&lang=js"
export * from "./ViNavBar.vue?vue&type=script&lang=js"
import style0 from "./ViNavBar.vue?vue&type=style&index=0&id=6aa6258c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa6258c",
  null
  
)

export default component.exports